import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
      topbar: {
          show: false
      },
      leftSidebar: {
          show: false,
          mode: "close"
      }
  },
  layout2Settings: {
      mode: "full",
      topbar: {
          show: false
      },
      navbar: { show: false }
  },
  secondarySidebar: { show: false },
  footer: { show: false }
};

const DMTReport = MatxLoadable({
  loader: () => import("./DMTReport")
})

const DMTReportRoutes = [
  {
    path: "/reports_sent_to_dmt",
    component: DMTReport,
    auth: authRoles.admin
  }
];

export default DMTReportRoutes;